export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const ERROR_SAVE_DATA = 'ERROR_SAVE_DATA';
export const INIT_DATA_PATH = 'INIT_DATA_PATH';
export const INIT_DOCUMENTS = 'INIT_DOCUMENTS';
export const INIT_BASE_URL = 'INIT_BASE_URL';
export const INIT_UUID = 'INIT_UUID';
export const INIT_TOKEN_INBANK = 'INIT_TOKEN_INBANK';
export const SAVE_DATA = 'SAVE_DATA';
export const STEP_AVANTI = 'STEP_AVANTI';
export const STEP_INDIETRO = 'STEP_INDIETRO';
export const STEP_INDIETRO_SKIP = 'STEP_INDIETRO_SKIP';
export const STEP_SECONDARY_DOCUMENTS = 'STEP_SECONDARY_DOCUMENTS';
export const ERROR_UUIDGET = "ERROR_UUIDGET";
export const ERROR_TOKENINBANK = "ERROR_TOKENINBANK";
export const ERROR_SALVA_STEP = 'ERROR_SALVA_STEP';
export const SALVA_DATI_GET_PREVENTIVO = 'SALVA_DATI_GET_PREVENTIVO';
export const SALVA_PREVENTIVO = 'SALVA_PREVENTIVO';
export const REMOVE_ASSICURAZIONE = 'REMOVE_ASSICURAZIONE';
export const MODIFICA_STEP = 'MODIFICA_STEP';
export const MODIFICA_PREVENTIVO = 'MODIFICA_PREVENTIVO';
export const SALVA_DATI = 'SALVA_DATI';
export const SALVA_CODICE_BROKER = 'SALVA_CODICE_BROKER';
export const SALVA_DOMANDA_QUESTIONARIO = 'SALVA_DOMANDA_QUESTIONARIO';
export const SALVA_QUESTIONARIO = 'SALVA_QUESTIONARIO';
export const SALVA_DATI_CODICE_FISCALE = 'SALVA_DATI_CODICE_FISCALE';
export const SALVA_DATI_IBAN = 'SALVA_DATI_IBAN';
export const CONTROLLO_CITTADINANZA = 'CONTROLLO_CITTADINANZA';
export const CONTROLLO_TELEFONO_CELLULARE= 'CONTROLLO_TELEFONO_CELLULARE';
export const CONTROLLO_TELEFONO_FISSO = 'CONTROLLO_TELEFONO_FISSO';
export const CONTROLLO_RESIDENZA = 'CONTROLLO_RESIDENZA';
export const CONTROLLO_RESIDENZA_PRECEDENTE = 'CONTROLLO_RESIDENZA_PRECEDENTE';
export const INIT_CONTROLLO_RESIDENZA = 'INIT_CONTROLLO_RESIDENZA';
export const INIT_CONTROLLO_RESIDENZA_PRECEDENTE = 'INIT_CONTROLLO_RESIDENZA_PRECEDENTE';
export const ERROR_CONTROLLO_CAP= 'ERROR_CONTROLLO_CAP';
export const ERROR_CONTROLLO_CAP_PRECEDENTE= 'ERROR_CONTROLLO_CAP_PRECEDENTE';
export const ERROR_CONTROLLO_CAP_AZIENDA= 'ERROR_CONTROLLO_CAP_AZIENDA';

export const CAP_RESIDENZA = 'CAP_RESIDENZA';
export const CAP_RESIDENZA_PRECEDENTE = 'CAP_RESIDENZA_PRECEDENTE';
export const CAP_RESIDENZA_AZIENDA = 'CAP_RESIDENZA_AZIENDA';

export const COMUNE_RESIDENZA = 'COMUNE_RESIDENZA';
export const COMUNE_RESIDENZA_PRECEDENTE = 'COMUNE_RESIDENZA_PRECEDENTE';
export const COMUNE_RESIDENZA_AZIENDA = 'COMUNE_RESIDENZA_AZIENDA';

export const PROVINCIA_DOCUMENTO_IDENTIFICATIVO = 'PROVINCIA_DOCUMENTO_IDENTIFICATIVO';


export const LISTA_PROVINCE_DOCUMENTO_IDENTIFICATIVO = 'LISTA_PROVINCE_DOCUMENTO_IDENTIFICATIVO';
export const LISTA_COMUNI_DOCUMENTO_IDENTIFICATIVO = 'LISTA_COMUNI_DOCUMENTO_IDENTIFICATIVO';
export const CAMBIO_ATTIVITA = 'CAMBIO_ATTIVITA';
export const CONTROLLO_RESIDENZA_AZIENDA = 'CONTROLLO_RESIDENZA_AZIENDA';
export const INIT_CONTROLLO_RESIDENZA_AZIENDA = 'INIT_CONTROLLO_RESIDENZA_AZIENDA';
export const INVIO_RICHIESTA = 'INVIO_RICHIESTA';
export const CAMBIO_CLIENTE_CCB = 'CAMBIO_CLIENTE_CCB';
export const CONTROLLO_ABITAZIONE_AFFITTO = 'CONTROLLO_ABITAZIONE_AFFITTO';
export const CAMBIO_DOCUMENTO = 'CAMBIO_DOCUMENTO';

export const CALCOLO_PREVENTIVO = 'CALCOLO_PREVENTIVO';
export const ERROR_CALCOLO_PREVENTIVO = 'ERROR_CALCOLO_PREVENTIVO';
export const DOWNLOAD_MODULO_SECCI = 'DOWNLOAD_MODULO_SECCI';
export const ERROR_DOWNLOAD_MODULO_SECCI = 'ERROR_DOWNLOAD_MODULO_SECCI';

export const SALVA_DOCUMENTI = 'SALVA_DOCUMENTI';
export const STEP_AVANTI_CONFERMA = 'STEP_AVANTI_CONFERMA';
export const STEP_AVANTI_FINE = 'STEP_AVANTI_FINE';

export const LOADING_UUIDGET_TRUE = 'LOADING_UUIDGET_TRUE';
export const LOADING_UUIDGET_FALSE = 'LOADING_UUIDGET_FALSE';
export const LOADING_INIZIALE_TRUE = 'LOADING_INIZIALE_TRUE';
export const LOADING_INIZIALE_FALSE = 'LOADING_INIZIALE_FALSE';
export const LOADING_TRUE = 'LOADING_TRUE';
export const LOADING_FALSE = 'LOADING_FALSE';
export const LOADING_PREVENTIVO_TRUE = 'LOADING_PREVENTIVO_TRUE';
export const LOADING_PREVENTIVO_FALSE = 'LOADING_PREVENTIVO_FALSE';
export const LOADING_CF_TRUE = 'LOADING_CF_TRUE';
export const LOADING_CF_FALSE = 'LOADING_CF_FALSE';
export const LOADING_COMUNI_TRUE = 'LOADING_COMUNI_TRUE';
export const LOADING_COMUNI_FALSE = 'LOADING_COMUNI_FALSE';
export const LOADING_PROVINCE_TRUE = 'LOADING_PROVINCE_TRUE';
export const LOADING_PROVINCE_FALSE = 'LOADING_PROVINCE_FALSE';
export const LOADING_CONFERMA_TRUE = 'LOADING_CONFERMA_TRUE';
export const LOADING_CONFERMA_FALSE = 'LOADING_CONFERMA_FALSE';
export const UPLOADING_ID_DOC_TRUE = 'UPLOADING_ID_DOC_TRUE';
export const UPLOADING_ID_DOC_FALSE = 'UPLOADING_ID_DOC_FALSE';
export const UPLOADING_HEALTH_DOC_TRUE = 'UPLOADING_HEALTH_DOC_TRUE';
export const UPLOADING_HEALTH_DOC_FALSE = 'UPLOADING_HEALTH_DOC_FALSE';
export const UPLOADING_INCOME_DOC_TRUE = 'UPLOADING_INCOME_DOC_TRUE';
export const UPLOADING_INCOME_DOC_FALSE = 'UPLOADING_INCOME_DOC_FALSE';

export const LOADING_RESIDENZA_TRUE = 'LOADING_RESIDENZA_TRUE';
export const LOADING_RESIDENZA_FALSE = 'LOADING_RESIDENZA_FALSE';
export const LOADING_RESIDENZA_PRECEDENTE_TRUE = 'LOADING_RESIDENZA_PRECEDENTE_TRUE';
export const LOADING_RESIDENZA_PRECEDENTE_FALSE = 'LOADING_RESIDENZA_PRECEDENTE_FALSE';
export const LOADING_RESIDENZA_AZIENDA_TRUE = 'LOADING_RESIDENZA_AZIENDA_TRUE';
export const LOADING_RESIDENZA_AZIENDA_FALSE = 'LOADING_RESIDENZA_AZIENDA_FALSE';

export const SALVA_DOCUMENTI_TRASPARENZA = 'SALVA_DOCUMENTI_TRASPARENZA';
export const CHANGE_PRIVACY_CHECKBOX = 'CHANGE_PRIVACY_CHECKBOX';
